import { SignIn } from "@clerk/tanstack-react-start";
import { createFileRoute } from "@tanstack/react-router";

import { ConnectPartnerSignIn } from "@/components/connect/partner-sign-in";
import {
  getSafeRedirectPath,
  redirectIfAuthenticated,
  validateAuthRedirectSearch,
} from "@/lib/auth-routing";
import { authorizeRequestFromSearch } from "@/lib/connect-partner";
import { seoHead } from "@/lib/seo";

export const Route = createFileRoute("/login/")({
  validateSearch: validateAuthRedirectSearch,
  head: () =>
    seoHead({
      title: "Log in - Bavimail",
      description: "Log in to your Bavimail dashboard.",
      path: "/login/",
      noindex: true,
    }),
  beforeLoad: async ({ search, preload }) => {
    if (preload) return;
    await redirectIfAuthenticated(search);
  },
  component: LoginRoute,
});

// A partner's authorize request (Connect Bavimail) skips the form and continues with that
// partner's identity provider; `connect=manual` brings the form back. Any other visit, including
// an authorize request of an unknown OAuth client (an MCP client), gets the form, and Clerk's
// component returns to `redirect_url` on its own.
function LoginRoute() {
  const search = Route.useSearch();
  const authorize = authorizeRequestFromSearch(search.redirect_url);
  if (authorize?.partner && search.connect !== "manual") {
    return <ConnectPartnerSignIn partner={authorize.partner} authorizeHref={authorize.href} />;
  }
  return <LoginAuthScreen redirectTo={search.redirectTo} />;
}

export function LoginAuthScreen({ redirectTo }: { redirectTo?: string }) {
  const fallbackRedirectUrl = getSafeRedirectPath(redirectTo);

  return (
    <main className="flex min-h-screen items-center justify-center bg-[#0d0d0f] px-4 py-10">
      <SignIn
        routing="hash"
        fallbackRedirectUrl={fallbackRedirectUrl}
        signUpFallbackRedirectUrl={fallbackRedirectUrl}
        transferable
        withSignUp
      />
    </main>
  );
}
